import { render, staticRenderFns } from "./fileUploader.vue?vue&type=template&id=1b4acc85&scoped=true&"
import script from "./fileUploader.vue?vue&type=script&lang=babel&"
export * from "./fileUploader.vue?vue&type=script&lang=babel&"
import style0 from "./fileUploader.vue?vue&type=style&index=0&id=1b4acc85&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4acc85",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VCardText,VFileInput,VIcon,VList,VTooltip})
